import { mountModal } from './helper/dynamic-modal';

export const confirm = (message: string | string[], props?: { textOk?: string; textCancel?: string }) => mountModal({ slot: message, props: { ...props, withActionButton: true, withCloseButton: false } }) as Promise<boolean>;
